import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
// import { AdalService } from './services/adal.service';
import { catchError, map, tap, mergeMap, switchMap } from 'rxjs/operators';
import {  Observable, of, from } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from './services/common.service';
import { EnvService } from './services/env.service';
import { LoaderService } from './loader/loader.service';
import { MsalService } from "@azure/msal-angular";
import { AuthenticationParameters } from "msal";
import { IdToken } from "msal/lib-commonjs/IdToken";
import { TokenClass } from "typescript";
import { InteractionRequiredAuthError } from "msal";
//import { from } from 'rxjs/observable/from';


@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  
  tokenVal: string;
  graphToken: string;
  authenticationParams: AuthenticationParameters;
  getAccessToken: any;
  
  

  constructor(private msal: MsalService, private toasterService: ToastrService, private loader: LoaderService) {
    var envConfig = new EnvService();
  
  }

intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
   
    var envConfig = new EnvService();

    return from(this.addAuthorizationHeader(request)).pipe(
      switchMap (updatedRequest => next.handle(updatedRequest)),catchError((err: any) =>
       {
        
        if (err instanceof HttpErrorResponse) 
        {
          this.loader.hide();

          if (err.url.includes('photo/$value')) {
            throw err;
          }

          if(request.url && request.url.includes('/userProfile'))
            throw err;

          if(request.url && request.url.includes('/media/icon'))
            throw err;

           if(err && err.error && err.error.statusCode==2)
           {
            if(err.error.errors && err.error.errors.length>0)
            {
              if(err.error.errors[0].fullMessage)
                this.toasterService.show(err.error.errors[0].fullMessage);
              }
            }
            if(err && err.error && err.error.statusCode==3){
              if(err.error.errors && err.error.errors.length>0)
              {
                if(err.error.errors[0].message != null)
                this.toasterService.show(err.error.errors[0].message);
            }
          }
        }
      
        return of(err);
   
      })
    );

}
   
async addAuthorizationHeader(request: HttpRequest<any>): Promise<HttpRequest<any>> {

     await this.getTokenMsal(request).then(res =>{
            request = res;
      });

      return request;
  }
   
getTokenMsal = async (request: HttpRequest<any>) => {
  var envConfig = new EnvService();
  var scope: string;
  var updatedRequest: any;
  const account = this.msal.getAccount();

  if (!account) {
    // No account, trigger login
    this.msal.loginRedirect();
    return request;
  }

  if (request.url && request.url.includes("graph.microsoft.com")) {
    scope = `${envConfig.endpoints}/.default`;
  } else {
    scope = `${envConfig.resource}/user_impersonation`;
  }

  try {
    await this.msal.acquireTokenSilent(this.getAuthenticationParams(scope)).then(res => {
      console.log(res);
      updatedRequest = request.clone({
        setHeaders: {
          Authorization: 'Bearer ' + res.accessToken
        }
      });
    });
  } catch (error) {
    //if (error instanceof InteractionRequiredAuthError) {
      // Fallback to interactive login
      localStorage.setItem('acquireTokensilent error:', error)
      console.log('acquireTokenRedirect before error:', error);
      this.msal.acquireTokenRedirect(this.getAuthenticationParams(scope));
      return request;
    // } else {
    //   throw error;
    // }
  }

  return updatedRequest;
}

getAuthenticationParams(scope : string){

  var envConfig = new EnvService();
  const accounts = this.msal.getAllAccounts();
  this.authenticationParams = {
    scopes: [scope],
    authority: `https://login.microsoftonline.com/${envConfig.tenant}`,
    account: accounts && accounts.length > 0 ? accounts[0] : null,
    redirectUri:  window.location.origin
  };

  return this.authenticationParams;

}
  
}
